module.exports = __webpack_public_path__ + "static/media/campaign-feature-1.396166ee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/campaign-feature-1.png
// module id = 610
// module chunks = 0